/**
 * Toggle nav dropdown.
 */

import $ from "jquery";

function handleDropdown(e) {
	const $this = $(this);
	const $li = $this.closest("li");

	if ($li.find(".dropdown").length > 0) {
		e.preventDefault();
		e.stopPropagation();

		$li
			.toggleClass("is-active")
			.find(".dropdown")
			.stop(true, true)
			.slideToggle()
			.closest("li")
			.siblings()
			.removeClass("is-active")
			.find(".dropdown")
			.slideUp();
	}
}

// Close dropdown when clicking outside
function closeDropdownOutside(e) {
	const $target = $(e.target);
	const $nav = $target.closest(".nav");

	// If click is outside the nav, close all dropdowns
	if (!$nav.length) {
		$(".nav li.is-active").each(function () {
			const $li = $(this);
			$li.removeClass("is-active").find(".dropdown").slideUp();
		});
		return;
	}

	// If click is inside nav but not on an active dropdown item or its dropdown
	const $clickedLi = $target.closest("li.menu-item-has-children");
	const $activeLi = $nav.find("li.is-active");

	if ($activeLi.length && (!$clickedLi.length || !$clickedLi.is($activeLi))) {
		// Check if click is inside the active dropdown
		if (!$target.closest(".dropdown").length) {
			$activeLi.removeClass("is-active").find(".dropdown").slideUp();
		}
	}
}

$(document).ready(function () {
	$(".nav a").on("click", handleDropdown);
	$(document).on("click", closeDropdownOutside);
});
